import { Link } from "react-router-dom";
import { newsList } from "@/mocks/news";

const hotTags = ["湖人", "勇士", "凯尔特人", "季后赛", "三分潮流", "新秀观察", "伤病动态", "东部格局"];

export default function NewsSidebar() {
  const [top, ...rest] = newsList.slice(0, 7);

  return (
    <div className="flex flex-col gap-5">
      <div className="bg-background-50 rounded-lg border border-background-200 p-4 md:p-5">
        <div className="flex items-center justify-between gap-3 mb-4">
          <div className="flex items-center gap-3">
            <span className="w-1.5 h-6 rounded-full bg-accent-500"></span>
            <h2 className="font-heading text-xl font-bold text-foreground-950">最新赛事新闻</h2>
          </div>
          <Link to="/news" className="text-sm text-foreground-500 hover:text-primary-600 flex items-center gap-1 whitespace-nowrap cursor-pointer">
            更多 <i className="ri-arrow-right-s-line"></i>
          </Link>
        </div>

        <Link to={`/news/${top.id}`} className="group block mb-3 cursor-pointer">
          <div className="w-full h-40 rounded-lg overflow-hidden bg-background-100">
            <img
              src={top.image}
              alt={top.title}
              title={`${top.title} - NBA直播吧新闻`}
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            />
          </div>
          <span className="inline-block mt-3 text-xs px-2 py-0.5 rounded bg-accent-100 text-accent-900 font-label">{top.category}</span>
          <h3 className="mt-2 font-heading text-base font-semibold text-foreground-950 leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">
            {top.title}
          </h3>
          <span className="mt-1 inline-block text-xs text-foreground-400 font-label">{top.publishTime}</span>
        </Link>

        <div className="border-t border-background-200 pt-1">
          {rest.map((n) => (
            <Link key={n.id} to={`/news/${n.id}`} className="group flex items-start gap-3 py-3 border-b border-background-200 last:border-0 cursor-pointer">
              <span className="w-9 h-9 shrink-0 rounded bg-background-100 text-primary-600 flex items-center justify-center">
                <i className="ri-newspaper-line"></i>
              </span>
              <div className="min-w-0">
                <h4 className="text-sm font-medium text-foreground-900 leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">
                  {n.title}
                </h4>
                <span className="mt-1 inline-block text-xs text-foreground-400 font-label">{n.publishTime}</span>
              </div>
            </Link>
          ))}
        </div>
      </div>

      <div className="bg-secondary-50 rounded-lg border border-secondary-200 p-4 md:p-5">
        <div className="flex items-center gap-3 mb-4">
          <span className="w-1.5 h-6 rounded-full bg-secondary-500"></span>
          <h2 className="font-heading text-lg font-bold text-foreground-950">热门标签合集</h2>
        </div>
        <div className="flex flex-wrap gap-2">
          {hotTags.map((t) => (
            <Link
              key={t}
              to="/news"
              className="px-3 py-1.5 rounded-full bg-background-50 border border-secondary-200 text-xs text-secondary-900 hover:border-secondary-400 hover:bg-secondary-100 transition-colors cursor-pointer"
            >
              # {t}
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}